// extracted by mini-css-extract-plugin
module.exports = {"child":"_1szFc3YSDD94llEnRnw-kT"};